var account = "Tili";
var accountSettings = "Tilin asetukset";
var charging = "Lataaminen";
var contactInfo = "Yhteystiedot";
var dashboard = "Etusivu";
var home = "Etusivu";
var myProducts = "Omat tuotteet";
var orderHistory = "Tilaushistoria";
var paymentMethod = "Maksutapa";
var profileSettings = "Profiilin asetukset";
var referAndEarn = "Suosittele ja ansaitse";
var signOut = "Kirjaudu ulos";
var fi_FI = {
	account: account,
	accountSettings: accountSettings,
	charging: charging,
	contactInfo: contactInfo,
	dashboard: dashboard,
	home: home,
	myProducts: myProducts,
	orderHistory: orderHistory,
	paymentMethod: paymentMethod,
	profileSettings: profileSettings,
	referAndEarn: referAndEarn,
	signOut: signOut
};

export { account, accountSettings, charging, contactInfo, dashboard, fi_FI as default, home, myProducts, orderHistory, paymentMethod, profileSettings, referAndEarn, signOut };
